/**
 * INDEX — docs/03 §3.4.
 *
 * The index is per **symbol**, not per market, so it survives the roll
 * untouched. It is the one continuous line on the screen, and it is why the
 * chart never blanks during the 13-second gap (§6.3).
 *
 * The module is named `index-prices` rather than `index` on purpose: a file
 * called `index.ts` inside `endpoints/` would be the directory's barrel, and
 * `import … from './endpoints/index'` would then silently mean something else.
 */

import type { HttpClient, RequestOptions } from '../client'
import type { OkBody, Page, OpQuery } from '../types'

export function indexEndpoints(client: HttpClient) {
  return {
    /** Cold load, once per asset in view, so `<StrikeMeter>` renders a real
     *  number before the first tick instead of a dash. */
    getIndexPrice(symbol: string, options?: RequestOptions) {
      return client.get<OkBody<'getIndexPrice'>>(`/index/${encodeURIComponent(symbol)}`, options)
    },

    /** Chart cold load in **price** mode. 300 one-second bars is five minutes —
     *  five markets, which is enough to see the chain of strikes. */
    getIndexCandles(symbol: string, query: OpQuery<'getIndexCandles'>, options?: RequestOptions) {
      return client.get<Page<OkBody<'getIndexCandles'>>>(
        `/index/${encodeURIComponent(symbol)}/candles`,
        { ...options, query },
      )
    },
  }
}

export type IndexEndpoints = ReturnType<typeof indexEndpoints>
